import { render, staticRenderFns } from "./LoaderMarketplaceIntegrate.vue?vue&type=template&id=45a23880&"
import script from "./LoaderMarketplaceIntegrate.vue?vue&type=script&lang=js&"
export * from "./LoaderMarketplaceIntegrate.vue?vue&type=script&lang=js&"
import style0 from "./LoaderMarketplaceIntegrate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports